import { getLocalTimeZone, now } from '@internationalized/date';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import type { OmitFunctions } from '@/types';
import { createSelectors } from './selector';

export type WeeklySqlFiltersState = {
  startDate: string | null;
  endDate: string | null;
  dislikesThreshold: number | null;
  percentageLessThan: number | null;
  percentageGreaterThan: number | null;

  setStartDate: (value: string | null) => void;
  setEndDate: (value: string | null) => void;
  setDislikesThreshold: (value: number | null) => void;
  setPercentageLessThan: (value: number | null) => void;
  setPercentageGreaterThan: (value: number | null) => void;
  setFilters: (filters: {
    startDate: string | null;
    endDate: string | null;
    dislikesThreshold?: number | null;
    percentageLessThan?: number | null;
    percentageGreaterThan?: number | null;
  }) => void;
  resetFilters: () => void;
};

const initialState: OmitFunctions<WeeklySqlFiltersState> = {
  startDate: now(getLocalTimeZone()).subtract({ days: 7 }).toString(),
  endDate: now(getLocalTimeZone()).toString(),
  dislikesThreshold: null,
  percentageLessThan: null,
  percentageGreaterThan: null,
};

const weeklySqlFiltersSlice = create<WeeklySqlFiltersState>()(
  persist(
    (set) => ({
      ...initialState,
      setStartDate: (startDate) => set({ startDate }),
      setEndDate: (endDate) => set({ endDate }),
      setDislikesThreshold: (dislikesThreshold) => set({ dislikesThreshold }),
      setPercentageLessThan: (percentageLessThan) => set({ percentageLessThan }),
      setPercentageGreaterThan: (percentageGreaterThan) => set({ percentageGreaterThan }),
      setFilters: (filters) =>
        set({
          startDate: filters.startDate ?? null,
          endDate: filters.endDate ?? null,
          dislikesThreshold: filters.dislikesThreshold ?? null,
          percentageLessThan: filters.percentageLessThan ?? null,
          percentageGreaterThan: filters.percentageGreaterThan ?? null,
        }),
      resetFilters: () => set(initialState),
    }),
    {
      name: 'quesmed-weekly-sql-filters',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        startDate: state.startDate,
        endDate: state.endDate,
        dislikesThreshold: state.dislikesThreshold,
        percentageLessThan: state.percentageLessThan,
        percentageGreaterThan: state.percentageGreaterThan,
      }),
    },
  ),
);

export const useWeeklySqlFilters = createSelectors(weeklySqlFiltersSlice);
